<template>
    <div class="store-box" >
         <div class="store-btn" @click="btnClick" refs="btn" >{{btnText}}</div>

    </div>

</template>
<script>
export default {
    props:{
        state:{
            type:String|Number,
            default:()=>{
                return 1
            }
        },
    },
    computed:{
        btnText:function(){
            if (this.state ==1) {
                return '保存下一步'
            }else if(this.state ==2) {
                return '保存下一步'
            }else if(this.state ==3) {
                return '保存'
            }else if(this.operationStatus=='1'){
                // console.log('编辑数据保存')
                return '保存'
            }

        },

    },

    data () {
        return {
            stepStatus:'0',
            allMoneydata:{},
            allInfodata:{}

        }
    },
    methods:{
        btnClick() {
            this.$emit('clickHandler')
        },


    },
    created(){
        this.stepStatus=this.$route.query.operationStatus
    }
}
</script>
<style scoped>
.store-box{
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    height: 1.4rem;
    padding-top: .2rem;
    text-align: center;
    background: #fff;
}
.store-btn{
  border:1.2px solid #5483D2 ;
  width:8rem;
  text-align:center ;
  height: 1rem;
  line-height: 1rem;
  border-radius: .5rem;
  margin: 0 auto;
  font-size: 14px;
  color: #5483D2;
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/TicketButton.vue